var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgBandcampLogoinline = function SvgBandcampLogoinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 15,
    viewBox: "0 0 25 15"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#639AA9",
    fillRule: "evenodd",
    d: "M16.933 14.834H0L7.907.074h16.934z"
  })));
};
export default SvgBandcampLogoinline;